import SnackBarComponent from '@efex-components/payables/addFundModal/components/CurrencySelector/SnackBarComponent';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@efexteam/components';
import { Box, Typography } from '@mui/material';
import { CURRENCY_IDS } from '@utils/formater';
import { useTranslation } from 'react-i18next';
import ActionModalStyles from './ActionModal.style';
import useActionModal from './hooks/useActionModal';
import { ActionModalProps, DetailRowProps } from './types/actionModal.type';

const DetailRow = ({ label, value }: DetailRowProps) => (
  <Box className={ActionModalStyles.contentItemRow}>
    <Typography variant="caption">{label}</Typography>
    <Typography variant="body2">{value || '---'}</Typography>
  </Box>
);

const ActionModal = ({ type, transfer, open, onClose }: ActionModalProps) => {
  const { t } = useTranslation();

  const { snackConfig, isSnackOpen, loading, handleConfirm, handleClose } =
    useActionModal(type, onClose);

  if (!transfer) {
    return null;
  }

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <DialogTitle showCloseButton onClick={handleClose}>
        {type === 'approve'
          ? t('trsfDtlActionModalApproveQuestion')
          : t('trsfDtlActionModalRejectQuestion')}
      </DialogTitle>
      <DialogContent>
        <Box className={ActionModalStyles.contentItem}>
          <DetailRow
            label={t('trsfDtlActionModalClientName')}
            value={transfer.contact?.enterprise?.name}
          />
          <DetailRow
            label={t('trsfDtlActionModalSendAmount')}
            value={`${transfer.amount} ${CURRENCY_IDS[transfer.currencyId]}`}
          />
          <DetailRow
            label={t('trsfDtlActionModalReceiveAmount')}
            value={`${transfer.desAmount} ${
              CURRENCY_IDS[transfer.desCurrencyId]
            }`}
          />
        </Box>
        {transfer.id && (
          <Box className={ActionModalStyles.buttonWrapper}>
            <Button
              appearance={type === 'approve' ? 'primary' : 'secondary'}
              onClick={() => handleConfirm(transfer.id.toString())}
              disabled={loading}
            >
              {loading
                ? t('loading') || ''
                : t(
                    type === 'approve'
                      ? 'trsfDtlModalActionConfirm'
                      : 'trsfDtlModalActionReject'
                  )}
            </Button>
          </Box>
        )}
      </DialogContent>
      <SnackBarComponent
        {...snackConfig}
        className={ActionModalStyles.snackWrapper}
        isOpen={isSnackOpen}
        variant="filled"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Dialog>
  );
};

export default ActionModal;
